<!--

	Shows the title of the tutorial video and when clicked, shows this video 

-->
<template>
	<div class="mia-TutorialVideo">
		<div class="list-group-item" :class="{ 'mia-Menu-item--selected': isVideoOpen }" @click.stop="isVideoOpen = true">
			<a class="mia-TutorialVideoHeading">
				<inline-svg src="@theme/icons/video_icon.svg" class="mia-TutorialVideoIcon" />
				<span class="mia-TutorialVideoTitle">{{ item.Title }}</span>
			</a>
		</div>
		<lightbox v-if="isVideoOpen" @close="isVideoOpen = false">
			<video autoplay controls :src="item.Url" />
		</lightbox>
	</div>
</template>
<script lang="ts">
import { DefaultTutorialVideo } from "@/Control/Vue/Defaults";
import { Component, toNative } from "vue-facing-decorator";
import Lightbox from "@/Control/Vue/Lesson/Lightbox.vue";
import { Item } from "@/Control/Vue/Lists/VueList/Items/Item";
import { MiaPlaza } from "@/Reinforced.Typings";
import InlineSvg from "vue-inline-svg";

@Component({
	components: {
		Lightbox,
		InlineSvg,
	},
})
export class TutorialVideo extends Item<MiaPlaza.ConfigModel.Video.IVideoSetting> {
	protected defaults = DefaultTutorialVideo;
	isVideoOpen = false;
}

export default toNative(TutorialVideo);
</script>
<style lang="scss">
.mia-TutorialVideo {
	&:hover {
		background-color: theme.$mia-color-themeContrast;
	}

	.mia-TutorialVideoHeading {
		display: flex;
		align-items: center;
		padding-left: theme.$mia-padding-panel;
		cursor: pointer;
	}

	.mia-TutorialVideoTitle {
		padding-left: theme.$mia-padding-panel-md;
		color: theme.$mia-color-menu;
		text-align: left;
		white-space: normal;
	}
}
</style>
